/**
 * @fileoverview gRPC-Web generated client stub for acompanha.notification.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/notification/v1/notification.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.notification = {};
proto.acompanha.notification.v1 = require('./notification_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.notification.v1.NotificationServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.notification.v1.NotificationServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.notification.v1.SubscribeNotificationRequest,
 *   !proto.acompanha.notification.v1.SubscribeNotificationResponse>}
 */
const methodDescriptor_NotificationService_Subscribe = new grpc.web.MethodDescriptor(
  '/acompanha.notification.v1.NotificationService/Subscribe',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.acompanha.notification.v1.SubscribeNotificationRequest,
  proto.acompanha.notification.v1.SubscribeNotificationResponse,
  /**
   * @param {!proto.acompanha.notification.v1.SubscribeNotificationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.notification.v1.SubscribeNotificationResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.notification.v1.SubscribeNotificationRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.notification.v1.SubscribeNotificationResponse>}
 *     The XHR Node Readable Stream
 */
proto.acompanha.notification.v1.NotificationServiceClient.prototype.subscribe =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/acompanha.notification.v1.NotificationService/Subscribe',
      request,
      metadata || {},
      methodDescriptor_NotificationService_Subscribe);
};


/**
 * @param {!proto.acompanha.notification.v1.SubscribeNotificationRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.notification.v1.SubscribeNotificationResponse>}
 *     The XHR Node Readable Stream
 */
proto.acompanha.notification.v1.NotificationServicePromiseClient.prototype.subscribe =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/acompanha.notification.v1.NotificationService/Subscribe',
      request,
      metadata || {},
      methodDescriptor_NotificationService_Subscribe);
};


module.exports = proto.acompanha.notification.v1;

